import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "transaction-classifications-page" };
const _hoisted_2 = { class: "mapped-cell" };
const _hoisted_3 = { class: "cell-value" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "colour-cell" };
const _hoisted_6 = { class: "cell-value" };
const _hoisted_7 = { class: "colour-cell" };
const _hoisted_8 = { class: "cell-value" };
const _hoisted_9 = {
    key: 0,
    class: "remap-content"
};
const _hoisted_10 = ["value"];
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
    value: null,
    disabled: ""
};
const _hoisted_13 = ["value"];
const _hoisted_14 = {
    key: 0,
    class: "remap-warning"
};
import { ref, computed, onMounted, useTemplateRef } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminTable from '@/admin/components/AdminTable.vue';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionClassificationsPage',
    setup(__props) {
        const admin = useAdmin();
        const obTable = useTemplateRef('obTable');
        const mgTable = useTemplateRef('mgTable');
        const loading = ref(false);
        const obTree = ref([]);
        const mgTree = ref([]);
        const showRemapDialog = ref(false);
        const remapTarget = ref(null);
        const remapMgId = ref(null);
        const remapMgClassification = ref(null);
        const showDeleteDialog = ref(false);
        const deleteRow = ref(null);
        const showToast = ref(false);
        const toastMessage = ref('');
        const toastColor = ref('success');
        const obColumns = [
            { field: 'classification', label: 'Classification', width: '1.2fr', sortable: true },
            { field: 'subClassification', label: 'Sub Classification', width: '1.2fr', sortable: true },
            { field: 'mappedTo', label: 'Mapped To', width: '2fr', sortable: true }
        ];
        const mgColumns = [
            { field: 'key', label: 'Key', width: '1fr', sortable: true, editable: true, type: 'text', placeholder: 'e.g. groceries' },
            { field: 'mgClassification', label: 'Classification', width: '1.2fr', sortable: true, editable: true, type: 'text', required: true, placeholder: 'e.g. Groceries' },
            { field: 'mgSubClassification', label: 'Sub Classification', width: '1.2fr', sortable: true, editable: true, type: 'text', placeholder: 'optional' },
            { field: 'iconPath', label: 'Icon Path', width: '1fr', sortable: true, editable: true, type: 'text', placeholder: 'e.g. groceries.svg' },
            { field: 'color', label: 'Colour', width: '110px', sortable: true, editable: true, type: 'color', placeholder: '#000000' },
            { field: 'categoryColor', label: 'Category Colour', width: '140px', sortable: true, editable: true, type: 'color', placeholder: '#000000' }
        ];
        const mgRows = computed(() => flattenMG(mgTree.value));
        const obRows = computed(() => flattenOB(obTree.value));
        const mgSelectOptions = computed(() => mgRows.value.map(r => ({
            id: r.id,
            label: r.mgClassification + (r.mgSubClassification ? ', ' + r.mgSubClassification : '')
        })));
        const mgClassificationNames = computed(() => {
            const set = new Set();
            mgRows.value.forEach(r => { if (r.mgClassification)
                set.add(r.mgClassification); });
            return [...set].sort();
        });
        const remapSubOptions = computed(() => {
            if (!remapMgClassification.value)
                return [];
            const matches = mgRows.value.filter(r => r.mgClassification === remapMgClassification.value);
            const opts = [];
            const parent = matches.find(r => !r.mgSubClassification);
            if (parent)
                opts.push({ id: parent.id, label: '(parent only — ' + parent.mgClassification + ')' });
            matches
                .filter(r => r.mgSubClassification)
                .sort((a, b) => a.mgSubClassification.localeCompare(b.mgSubClassification))
                .forEach(r => opts.push({ id: r.id, label: r.mgSubClassification }));
            return opts;
        });
        function onRemapClassificationChange() {
            remapMgId.value = null;
        }
        const remapWarning = computed(() => {
            if (!remapTarget.value || !remapMgId.value)
                return null;
            const target = mgRows.value.find(r => r.id === remapMgId.value);
            if (!target)
                return null;
            if (remapTarget.value.subClassification && !target.mgSubClassification) {
                return 'You are mapping a child classification directly to a parent. This will lose the granularity of the child name.';
            }
            return null;
        });
        function classificationMGDisplayName(c) {
            if (!c)
                return '';
            return `${c.mgClassification}${c.mgSubClassification != null ? ', ' + c.mgSubClassification : ''}`;
        }
        function flattenMG(list) {
            return (list || []).map((c) => ({
                id: c.id,
                key: c.key || '',
                mgClassification: c.mgClassification,
                mgSubClassification: c.mgSubClassification || '',
                iconPath: c.iconPath || '',
                color: c.color || '',
                categoryColor: c.categoryColor || '',
                grandParent: c.grandParentClassification,
                raw: c
            }));
        }
        function flattenOB(list) {
            return (list || []).map((ob) => {
                const mapped = ob.mgClassification || null;
                return {
                    id: ob.id,
                    classification: ob.classification,
                    subClassification: ob.subClassification || '',
                    mappedTo: mapped ? classificationMGDisplayName(mapped) : '',
                    mgClassificationId: mapped ? mapped.id : null,
                    raw: ob
                };
            });
        }
        function loadAll() {
            loading.value = true;
            let mgDone = false;
            let obDone = false;
            const finish = () => { if (mgDone && obDone)
                loading.value = false; };
            admin.getEffectiveClassifications((data) => { mgTree.value = data || []; mgDone = true; finish(); });
            admin.getOpenBankingClassifications((data) => { obTree.value = data || []; obDone = true; finish(); });
        }
        function showSuccess(msg) {
            toastMessage.value = msg;
            toastColor.value = 'success';
            showToast.value = true;
        }
        function showError(msg) {
            toastMessage.value = msg;
            toastColor.value = 'error';
            showToast.value = true;
        }
        function cleanPayload(data) {
            const out = {};
            for (const k in data) {
                out[k] = data[k] === '' ? null : data[k];
            }
            return out;
        }
        // MG handlers
        function handleMGAdd(data) {
            if (!data.mgClassification) {
                showError('Classification name is required');
                return;
            }
            const payload = cleanPayload({
                key: data.key,
                mgClassification: data.mgClassification,
                mgSubClassification: data.mgSubClassification,
                iconPath: data.iconPath,
                color: data.color,
                categoryColor: data.categoryColor,
                grandParentClassification: typeof data.grandParent === 'number' ? data.grandParent : 0
            });
            admin.createTransactionClassification(payload, () => {
                showSuccess('Classification created');
                mgTable.value?.resetAddRow();
                loadAll();
            }, (err) => showError(err));
        }
        function handleMGEditSave({ rowId, data }) {
            const existing = mgRows.value.find(r => r.id === rowId);
            if (!existing)
                return;
            const newCategoryColor = data.categoryColor || null;
            const categoryColorChanged = (newCategoryColor || null) !== (existing.categoryColor || null);
            const payload = cleanPayload({
                id: rowId,
                key: data.key,
                mgClassification: data.mgClassification,
                mgSubClassification: data.mgSubClassification,
                iconPath: data.iconPath,
                color: data.color,
                categoryColor: newCategoryColor,
                grandParentClassification: existing.grandParent
            });
            const onMainSaved = () => {
                if (!categoryColorChanged) {
                    showSuccess('Classification saved');
                    mgTable.value?.cancelEdit();
                    loadAll();
                    return;
                }
                // categoryColor is denormalised across siblings — propagate to every other row
                // sharing the same mgClassification name.
                const siblings = mgRows.value.filter(r => r.id !== rowId && r.mgClassification === existing.mgClassification);
                if (siblings.length === 0) {
                    showSuccess('Classification saved');
                    mgTable.value?.cancelEdit();
                    loadAll();
                    return;
                }
                let remaining = siblings.length;
                let failed = 0;
                siblings.forEach(sib => {
                    const sibPayload = cleanPayload({
                        id: sib.id,
                        key: sib.key,
                        mgClassification: sib.mgClassification,
                        mgSubClassification: sib.mgSubClassification,
                        iconPath: sib.iconPath,
                        color: sib.color,
                        categoryColor: newCategoryColor,
                        grandParentClassification: sib.grandParent
                    });
                    admin.updateTransactionClassification(sib.id, sibPayload, () => {
                        remaining -= 1;
                        if (remaining === 0) {
                            if (failed === 0)
                                showSuccess(`Category colour applied to ${siblings.length + 1} rows`);
                            else
                                showError(`Updated, but ${failed} sibling row(s) failed`);
                            mgTable.value?.cancelEdit();
                            loadAll();
                        }
                    }, () => {
                        remaining -= 1;
                        failed += 1;
                        if (remaining === 0) {
                            showError(`Updated, but ${failed} sibling row(s) failed`);
                            mgTable.value?.cancelEdit();
                            loadAll();
                        }
                    });
                });
            };
            admin.updateTransactionClassification(rowId, payload, onMainSaved, (err) => showError(err));
        }
        function handleMGDelete(row) {
            deleteRow.value = row;
            showDeleteDialog.value = true;
        }
        function confirmMGDelete() {
            if (!deleteRow.value)
                return;
            const id = deleteRow.value.id;
            admin.deleteTransactionClassification(id, () => {
                showSuccess('Classification deleted');
                deleteRow.value = null;
                showDeleteDialog.value = false;
                loadAll();
            }, (err) => {
                showError(err);
                showDeleteDialog.value = false;
            });
        }
        // OB remap
        function openRemap(row) {
            remapTarget.value = row;
            const current = row.mgClassificationId ? mgRows.value.find(r => r.id === row.mgClassificationId) : null;
            remapMgClassification.value = current ? current.mgClassification : null;
            remapMgId.value = current ? current.id : null;
            showRemapDialog.value = true;
        }
        function closeRemap() {
            showRemapDialog.value = false;
            remapTarget.value = null;
            remapMgClassification.value = null;
            remapMgId.value = null;
        }
        function confirmRemap() {
            if (!remapTarget.value || !remapMgId.value)
                return;
            const mg = mgRows.value.find(r => r.id === remapMgId.value);
            if (!mg || !mg.raw)
                return;
            admin.remapOpenBankingClassification(remapTarget.value.raw, mg.raw, () => {
                showSuccess('Classification remapped');
                closeRemap();
                loadAll();
            }, (err) => showError(err));
        }
        onMounted(() => {
            loadAll();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Transaction Classifications"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage Open Banking mappings and the customer-facing Effective classifications.")
                ], -1)),
                _createVNode(AdminTable, {
                    ref_key: "obTable",
                    ref: obTable,
                    title: "Open Banking Classifications",
                    icon: "🏦",
                    columns: obColumns,
                    data: obRows.value,
                    loading: loading.value,
                    searchable: true,
                    "search-placeholder": "Search OB classifications...",
                    collapsible: true,
                    "default-expanded": true,
                    editable: false,
                    selectable: false,
                    deletable: false,
                    addable: false,
                    badge: obRows.value.length,
                    "empty-message": "No Open Banking classifications loaded."
                }, {
                    "cell-mappedTo": _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(row.mappedTo), 1),
                            _createElementVNode("button", {
                                class: "action-btn-small",
                                onClick: _withModifiers(($event) => (openRemap(row)), ["stop"]),
                                title: "Remap"
                            }, "↪️ Remap", 8, _hoisted_4)
                        ])
                    ]),
                    _: 1
                }, 8, ["data", "loading", "badge"]),
                _createVNode(AdminTable, {
                    ref_key: "mgTable",
                    ref: mgTable,
                    title: "Effective Classifications",
                    icon: "🏷️",
                    columns: mgColumns,
                    data: mgRows.value,
                    loading: loading.value,
                    searchable: true,
                    "search-placeholder": "Search effective classifications...",
                    collapsible: true,
                    "default-expanded": true,
                    editable: true,
                    selectable: false,
                    deletable: true,
                    addable: true,
                    badge: mgRows.value.length,
                    "empty-message": "No effective classifications yet. Add one below.",
                    onRowEditSave: handleMGEditSave,
                    onRowDelete: handleMGDelete,
                    onRowAdd: handleMGAdd
                }, {
                    "cell-color": _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", {
                                class: "colour-swatch",
                                style: _normalizeStyle({ background: row.color || 'transparent' })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(row.color || '—'), 1)
                        ])
                    ]),
                    "cell-categoryColor": _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", {
                                class: "colour-swatch",
                                style: _normalizeStyle({ background: row.categoryColor || 'transparent' })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(row.categoryColor || '—'), 1)
                        ])
                    ]),
                    _: 1
                }, 8, ["data", "loading", "badge"]),
                _createVNode(MGDialog, {
                    modelValue: showRemapDialog.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showRemapDialog).value = $event)),
                    title: "Remap Open Banking Classification",
                    "max-width": "420px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        (remapTarget.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("p", null, [
                                    _cache[7] || (_cache[7] = _createTextVNode("Open Banking: ")),
                                    _createElementVNode("strong", null, _toDisplayString(remapTarget.value.classification) + _toDisplayString(remapTarget.value.subClassification ? ', ' + remapTarget.value.subClassification : ''), 1)
                                ]),
                                _createElementVNode("p", null, [
                                    _cache[8] || (_cache[8] = _createTextVNode("Currently mapped to: ")),
                                    _createElementVNode("strong", null, _toDisplayString(remapTarget.value.mappedTo || '—'), 1)
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("label", null, "Classification:", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((remapMgClassification).value = $event)),
                                    onChange: onRemapClassificationChange,
                                    class: "remap-select"
                                }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("option", {
                                        value: null,
                                        disabled: ""
                                    }, "Select a classification…", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mgClassificationNames.value, (name) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: name,
                                            value: name
                                        }, _toDisplayString(name), 9, _hoisted_10));
                                    }), 128))
                                ], 544), [
                                    [_vModelSelect, remapMgClassification.value]
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Sub-classification:", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((remapMgId).value = $event)),
                                    class: "remap-select",
                                    disabled: !remapMgClassification.value
                                }, [
                                    _createElementVNode("option", _hoisted_12, _toDisplayString(remapMgClassification.value ? 'Select a sub-classification…' : 'Pick a classification first'), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remapSubOptions.value, (opt) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: opt.id,
                                            value: opt.id
                                        }, _toDisplayString(opt.label), 9, _hoisted_13));
                                    }), 128))
                                ], 8, _hoisted_11), [
                                    [_vModelSelect, remapMgId.value]
                                ]),
                                (remapWarning.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(remapWarning.value), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Save",
                            onClick: confirmRemap,
                            stacked: true,
                            disabled: !remapMgId.value
                        }, null, 8, ["disabled"]),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: closeRemap,
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteDialog.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showDeleteDialog).value = $event)),
                    title: "Delete Classification",
                    "max-width": "360px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, [
                            _cache[12] || (_cache[12] = _createTextVNode("Delete ")),
                            _createElementVNode("strong", null, _toDisplayString(deleteRow.value ? deleteRow.value.mgClassification + (deleteRow.value.mgSubClassification ? ', ' + deleteRow.value.mgSubClassification : '') : ''), 1),
                            _cache[13] || (_cache[13] = _createTextVNode("?"))
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Any Open Banking classifications mapped to this will be restored to their original Open Banking form.", -1))
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmMGDelete,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[3] || (_cache[3] = ($event) => (showDeleteDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showToast.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: toastColor.value
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event) => (showToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(toastMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue", "color"])
            ]));
        };
    }
});
